const images = {
    home_background: require('../images/home_background@3x.png'),
    sc_background: require('../images/sc_background@3x.png'),
    league_background: require('../images/league_background@3x.png'),
    login_background: require('../images/login_background@3x.png'),
    modal_background: require('../images/modal_background@3x.png'),
    splash_background: require('../images/splash_background@3x.png'),
    leaderboard_background: require('../images/leaderboard_background@3x.png'),
    leaderboard_background2: require('../images/leaderboard_background2@3x.png'),
    cc_logo: require('../images/cc_logo@3x.png'),
    coinsTextBase : require('../images/coins_text_base@3x.png'),
    coinsBase : require('../images/coins_base@3x.png'),
    // splash_background: require('../images/spBackGround@3x.png'),
    icons: {
        old : {
            arrow_down_00b4c1_40: require('./../images/icons/old/arrow_down_00b4c1_40.png'),
            arrow_down_154352_40: require('./../images/icons/old/arrow_down_154352_40.png'),
            arrow_left_ffffff_40: require('./../images/icons/old/arrow_left_ffffff_40.png'),
            arrow_right_154352_40: require('./../images/icons/old/arrow_right_154352_40.png'),
            arrow_right_ffffff_40: require('./../images/icons/old/arrow_right_ffffff_40.png'),
            ball_ffffff_100: require('./../images/icons/old/ball_ffffff_100.png'),
            bell_icon_00b4c1_132: require('./../images/icons/old/bell_icon_00b4c1_132.png'),
            camera_77a4af_150: require('./../images/icons/old/camera_77a4af_150.png'),
            circle_0095b7_60: require('./../images/icons/old/circle_0095b7_60.png'),
            circle_154352_160: require('./../images/icons/old/circle_154352_160.png'),
            circle_eb516c_60: require('./../images/icons/old/circle_eb516c_60.png'),
            done_icon_00c6c4_132: require('./../images/icons/old/done_icon_00c6c4_132.png'),
            edit_profile:require('./../images/icons/old/edit_profile.png'),
            enter_icon_154352_150: require('./../images/icons/old/enter_icon_154352_150.png'),
            enter_leagues_0e2c37_150: require('./../images/icons/old/enter_leagues_0e2c37_150.png'),
            fb_icon_160: require('./../images/icons/old/fb_icon_160.png'),
            g_plus_icon_160: require('./../images/icons/old/g_plus_icon_160.png'),
            hamburger_0095b7_100: require('./../images/icons/old/hamburger_0095b7_100.png'),
            hamburger_03808f_100: require('./../images/icons/old/hamburger_03808f_100.png'),
            horizontal_logo_645_145: require('./../images/icons/old/horizontal_logo_645_145.png'),
            lang_bn_icon_0094bb_132: require('./../images/icons/old/lang_bn_icon_0094bb_132.png'),
            lang_en_icon_0094bb_132: require('./../images/icons/old/lang_en_icon_0094bb_132.png'),
            lang_hi_icon_0094bb_132: require('./../images/icons/old/lang_hi_icon_0094bb_132.png'),
            lang_si_icon_0094bb_132: require('./../images/icons/old/lang_si_icon_0094bb_132.png'),
            lang_ta_icon_0094bb_132: require('./../images/icons/old/lang_ta_icon_0094bb_132.png'),
            left_icon_fff_132: require('./../images/icons/old/left_icon_fff_132.png'),
            loading_icon: require('./../images/icons/old/loading.png'),
            location_icon_154352_120: require('./../images/icons/old/location_icon_154352_120.png'),
            location_icon_eb516c_120: require('./../images/icons/old/location_icon_eb516c_120.png'),
            logout_icon_547988_100: require('./../images/icons/old/logout_icon_547988_100.png'),
            lost_icon_150: require('./../images/icons/old/lost_icon_150.png'),
            mail_icon_FFF_132: require('./../images/icons/old/mail_icon_fff_132.png'),
            penta_logo_1254: require('./../images/icons/old/penta_logo_1254.png'),
            pick_entry_0e2c37_150: require('./../images/icons/old/pick_entry_0e2c37_150.png'),
            pick_icon_154352_150: require('./../images/icons/old/pick_icon_154352_150.png'),
            play_icon_ff4d6c_120: require('./../images/icons/old/play_icon_ff4d6c_120.png'),
            profile_pic_plh: require('./../images/icons/old/profile_pic_plh.png'),
            refunded_icon_150: require('./../images/icons/old/refunded_icon_150.png'),
            right_icon_fff_132: require('./../images/icons/old/right_icon_fff_132.png'),
            score_points_icon_0e2c37_150: require('./../images/icons/old/score_points_icon_0e2c37_150.png'),
            setting_icon_ffffff_132: require('./../images/icons/old/setting_icon_ffffff_132.png'),
            share_icon_fff_132: require('./../images/icons/old/share_icon_fff_132.png'),
            sponsor_banner_sample: require('./../images/icons/old/sponsor_banner_sample.png'),
            stumps_left_ffffff_100: require('./../images/icons/old/stumps_left_ffffff_100.png'),
            stumps_right_ffffff_100: require('./../images/icons/old/stumps_right_ffffff_100.png'),
            tab_hamburger_icon_00bfc4_160: require('./../images/icons/old/tab_hamburger_icon_00bfc4_160.png'),
            tab_hamburger_icon_eb516c_160: require('./../images/icons/old/tab_hamburger_icon_eb516c_160.png'),
            tab_home_icon_00bfc4_160: require('./../images/icons/old/tab_home_icon_00bfc4_160.png'),
            tab_home_icon_eb516c_160: require('./../images/icons/old/tab_home_icon_eb516c_160.png'),
            tab_leaderboard_icon_00bfc4_160: require('./../images/icons/old/tab_leaderboard_icon_00bfc4_160.png'),
            tab_leaderboard_icon_eb516c_160: require('./../images/icons/old/tab_leaderboard_icon_eb516c_160.png'),
            tab_messages_00bfc4_160: require('./../images/icons/old/tab_messages_00bfc4_160.png'),
            tab_messages_eb516c_160: require('./../images/icons/old/tab_messages_eb516c_160.png'),
            tab_notifications_eb516c_160: require('./../images/icons/old/tab_notifications_eb516c_160.png'),
            tab_notifications_00bfc4_160: require('./../images/icons/old/tab_notifications_00bfc4_160.png'),
            tab_profile_icon_00bfc4_160: require('./../images/icons/old/tab_profile_icon_00bfc4_160.png'),
            tab_profile_icon_eb516c_160: require('./../images/icons/old/tab_profile_icon_eb516c_160.png'),
            tab_tokens_00bfc4_160: require('./../images/icons/old/tab_tokens_00bfc4_160.png'),
            tab_tokens_eb516c_160: require('./../images/icons/old/tab_tokens_eb516c_160.png'),
            win_icon_154352_150: require('./../images/icons/old/win_icon_154352_150.png'),
            win_coins_0e2c37_150: require('./../images/icons/old/win_coins_0e2c37_150.png'),
            won_icon_150: require('./../images/icons/old/won_icon_150.png'),
        },
        disabled : {
            coinsPile: require('./../images/icons/disabled/coinsPile.png'),
            league: require('./../images/icons/disabled/league.png')
        },
        about : require('./../images/icons/about@3x.png'),
        avatar : require('./../images/icons/avatar@3x.png'),
        back : require('./../images/icons/back@2x.png'),
        chat : require('./../images/icons/chat@3x.png'),
        clock : require('./../images/icons/clock@3x.png'),
        close : require('../images/icons/close@3x.png'),
        coins : require('../images/icons/coins@3x.png'),
        coinsBase : require('../images/icons/coinsBase@3x.png'),
        coinsPile : require('../images/icons/coinsPile@3x.png'),
        coinsPileDark : require('../images/icons/coinsPileDark@3x.png'),
        coinsPlus : require('../images/icons/coinsPlus@3x.png'),
        coinsTextBase : require('../images/icons/coinsTextBase@3x.png'),
        dreamTeam : require('../images/icons/dreamteam@3x.png'),
        edition : require('../images/icons/edition@3x.png'),
        faq : require('../images/icons/faq@3x.png'),
        ficaLogo : require('../images/icons/ficaLogo@3x.png'),
        ficaLogo2 : require('../images/icons/ficaLogo2@3x.png'),
        groupChat : require('../images/icons/groupChat@3x.png'),
        help : require('./../images/icons/help@3x.png'),
        howscorescalculated : require('./../images/icons/howscorescalculated@3x.png'),
        howtoplay : require('./../images/icons/howtoplay@3x.png'),
        info : require('../images/icons/info@3x.png'),
        inviteFriends : require('../images/icons/inviteFriends@3x.png'),
        lb_divider : require('../images/icons/lb_divider@3x.png'),
        leaderboard : require('../images/icons/leaderboard@3x.png'),
        league : require('../images/icons/league@3x.png'),
        live : require('./../images/icons/live@3x.png'),
        livePrediction : require('./../images/icons/livePrediction@3x.png'),
        logout : require('./../images/icons/logout@3x.png'),
        menu : require('./../images/icons/menu@3x.png'),
        more : require('./../images/icons/more@3x.png'),
        notification : require('./../images/icons/notification@3x.png'),
        notification2 : require('./../images/icons/notification2@3x.png'),
        play : require('./../images/icons/play@3x.png'),
        player0 : require('./../images/icons/player0@3x.png'),
        player1 : require('./../images/icons/player1@3x.png'),
        player2 : require('./../images/icons/player2@3x.png'),
        privacy : require('./../images/icons/privacy@3x.png'),
        profile : require('./../images/icons/profile@3x.png'),
        plus: require('./../images/icons/plus@3x.png'),
        rewardBanner : require('./../images/icons/rewardBanner@3x.png'),
        scBanner : require('../images/icons/scBanner@3x.png'),
        scBannerDisabled : require('../images/scBannerDisabled@3x.png'),
        selected : require('./../images/icons/selected@3x.png'),
        settings : require('./../images/icons/settings@3x.png'),
        sideBarClose: require('./../images/icons/sideBarClose@3x.png'),
        sponsorBanner : require('./../images/icons/sponsorBanner@3x.png'),
        success : require('../images/icons/success@3x.png'),
        targetPrediction : require('../images/icons/targetPrediction@3x.png'),
        trophy : require('../images/icons/trophy@3x.png'),
        upcoming : require('./../images/icons/upcoming@3x.png'),
        warning : require('../images/icons/warning@3x.png'),
        winBanner : require('../images/icons/winBanner@3x.png'),
        winnerBadge : require('../images/icons/winnerBadge@3x.png'),
    },
    d_flags:{
        afg: require('./../images/flags/disabled/afg@3x.png'),
        afgw: require('./../images/flags/disabled/afg@3x.png'),
        aus: require('../images/flags/disabled/aus@3x.png'),
        ausw: require('../images/flags/disabled/aus@3x.png'),
        ban: require('../images/flags/disabled/ban@3x.png'),
        banw: require('../images/flags/disabled/ban@3x.png'),
        can: require('../images/flags/disabled/can@3x.png'),
        csk: require('../images/flags/disabled/csk@3x.png'),
        dd: require('../images/flags/disabled/dd@3x.png'),
        canw: require('../images/flags/disabled/can@3x.png'),
        eng: require('../images/flags/disabled/eng@3x.png'),
        engw: require('../images/flags/disabled/eng@3x.png'),
        hk: require('../images/flags/disabled/hk@3x.png'),
        hkw: require('../images/flags/disabled/hk@3x.png'),
        ind: require('../images/flags/disabled/ind@3x.png'),
        indw: require('../images/flags/disabled/ind@3x.png'),
        ire: require('../images/flags/disabled/ire@3x.png'),
        irew: require('../images/flags/disabled/ire@3x.png'),
        ken: require('../images/flags/disabled/ken@3x.png'),
        kkr: require('../images/flags/disabled/kkr@3x.png'),
        kxip: require('../images/flags/disabled/kxip@3x.png'),
        mi: require('../images/flags/disabled/mi@3x.png'),
        kenw: require('../images/flags/disabled/ken@3x.png'),
        nep: require('../images/flags/disabled/nep@3x.png'),
        nepw: require('../images/flags/disabled/nep@3x.png'),
        nl: require('../images/flags/disabled/nl@3x.png'),
        nlw: require('../images/flags/disabled/nl@3x.png'),
        nz: require('../images/flags/disabled/nz@3x.png'),
        nzw: require('../images/flags/disabled/nz@3x.png'),
        pak: require('../images/flags/disabled/pak@3x.png'),
        pakw: require('../images/flags/disabled/pak@3x.png'),
        rcb: require('../images/flags/disabled/rcb@3x.png'),
        rr: require('../images/flags/disabled/rr@3x.png'),
        rsa: require('../images/flags/disabled/rsa@3x.png'),
        rsaw: require('../images/flags/disabled/rsa@3x.png'),
        sct: require('../images/flags/disabled/sct@3x.png'),
        sctw: require('../images/flags/disabled/sct@3x.png'),
        sl: require('../images/flags/disabled/sl@3x.png'),
        srh: require('../images/flags/disabled/srh@3x.png'),
        slw: require('../images/flags/disabled/sl@3x.png'),
        uae: require('../images/flags/disabled/uae@3x.png'),
        uaew: require('../images/flags/disabled/uae@3x.png'),
        uk: require('../images/flags/disabled/uk@3x.png'),
        wi: require('../images/flags/disabled/wi@3x.png'),
        wiw: require('../images/flags/disabled/wi@3x.png'),
        zim: require('../images/flags/disabled/zim@3x.png'),
        zimw: require('../images/flags/disabled/zim@3x.png'),
        default: require('../images/flags/disabled/default@3x.png'),
    },
    flags: {
        afg: require('../images/flags/afg@3x.png'),
        afgw: require('../images/flags/afg@3x.png'),
        aus: require('../images/flags/aus@3x.png'),
        ausw: require('../images/flags/aus@3x.png'),
        ban: require('../images/flags/ban@3x.png'),
        banw: require('../images/flags/ban@3x.png'),
        can: require('../images/flags/can@3x.png'),
        csk: require('../images/flags/csk@3x.png'),
        dd: require('../images/flags/dd@3x.png'),
        canw: require('../images/flags/can@3x.png'),
        eng: require('../images/flags/eng@3x.png'),
        engw: require('../images/flags/eng@3x.png'),
        hk: require('../images/flags/hk@3x.png'),
        hkw: require('../images/flags/hk@3x.png'),
        ind: require('../images/flags/ind@3x.png'),
        indw: require('../images/flags/ind@3x.png'),
        ire: require('../images/flags/ire@3x.png'),
        irew: require('../images/flags/ire@3x.png'),
        ken: require('../images/flags/ken@3x.png'),
        kkr: require('../images/flags/kkr@3x.png'),
        kxip: require('../images/flags/kxip@3x.png'),
        mi: require('../images/flags/mi@3x.png'),
        kenw: require('../images/flags/ken@3x.png'),
        nep: require('../images/flags/nep@3x.png'),
        nepw: require('../images/flags/nep@3x.png'),
        nl: require('../images/flags/nl@3x.png'),
        nlw: require('../images/flags/nl@3x.png'),
        nz: require('../images/flags/nz@3x.png'),
        nzw: require('../images/flags/nz@3x.png'),
        pak: require('../images/flags/pak@3x.png'),
        pakw: require('../images/flags/pak@3x.png'),
        rcb: require('../images/flags/rcb@3x.png'),
        rr: require('../images/flags/rr@3x.png'),
        rsa: require('../images/flags/rsa@3x.png'),
        rsaw: require('../images/flags/rsa@3x.png'),
        sct: require('../images/flags/sct@3x.png'),
        sctw: require('../images/flags/sct@3x.png'),
        sl: require('../images/flags/sl@3x.png'),
        srh: require('../images/flags/srh@3x.png'),
        slw: require('../images/flags/sl@3x.png'),
        uae: require('../images/flags/uae@3x.png'),
        uaew: require('../images/flags/uae@3x.png'),
        uk: require('../images/flags/uk@3x.png'),
        wi: require('../images/flags/wi@3x.png'),
        wiw: require('../images/flags/wi@3x.png'),
        zim: require('../images/flags/zim@3x.png'),
        zimw: require('../images/flags/zim@3x.png'),
        default: require('../images/flags/default@3x.png'),
    },
    langs: {
        bn: require('./../images/icons/old/lang_bn_icon_0094bb_132.png'),
        en: require('./../images/icons/old/lang_en_icon_0094bb_132.png'),
        hi: require('./../images/icons/old/lang_hi_icon_0094bb_132.png'),
        si: require('./../images/icons/old/lang_si_icon_0094bb_132.png'),
        ta: require('./../images/icons/old/lang_ta_icon_0094bb_132.png'),
    }
};

let getFlag = function (key, disabled) {
    var flag = images.flags[key];
    if(disabled && disabled===true){
        flag = images.d_flags[key];
        return (flag != null ?  flag : images.d_flags.default);
    }
    else {
        return (flag != null ? flag : images.flags.default)
    }
};

let getLang = function (key) {
    var lang = images.langs[key];
    return (lang != null ? lang : images.flags.default_100)
};

let getIcon = function(key) {
    var icon = images.icons[key];
    return (icon != null ? icon : images.flags.default_100)
}

export {images, getFlag, getIcon, getLang};


// WEBPACK FOOTER //
// ./src/app/config/images.js